import { useProfileService } from 'services/ProfileService';
import { EContractStatus } from 'types/teacherRecruitment';
import { useGetTeacherRecruitment } from './query/teacherRecruit/use-get-teacher-recruitment';

export const useLatestContractStatus = () => {
  const { profile } = useProfileService();
  const { data: teacherRecruitmentData } = useGetTeacherRecruitment({
    enabled: !!profile.oneClubId,
  });

  const isContractEmpty =
    Object.keys(teacherRecruitmentData || {}).length === 0;

  const hasSignedLatestContract =
    !isContractEmpty &&
    teacherRecruitmentData?.contractStatus &&
    teacherRecruitmentData?.contractStatus === EContractStatus.ACCEPTED;

  return {
    isSigned: Boolean(hasSignedLatestContract),
  };
};
